var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pa-4 d-flex justify-space-between align-center"},[_c('div',[_c('Breadcrumbs',{attrs:{"headline":"Sổ sách Giáo viên","link":[
          {
            text: 'Cấp học',
            href: '/teachingDoc'
          },
          {
            text: 'Sổ sách giảng dạy'
          }
        ]}})],1)]),_c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"center-screen"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',_vm._l((_vm.organizedData),function(node,index){return _c('div',{key:index},[_c('TreeNode',{attrs:{"node":node}})],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }